































import Vue, { VueConstructor } from 'vue';
import { AxiosResponse, AxiosError } from 'axios';
import { ToastMessage } from '@/plugins/toast/models/message';
import lang from '../../common/lang/de';
import { ErrorStatesOptions, SpecialSituationMessage } from '../../models';
import services from '../../services';
import mapper from '../../views/CallCenter/Settings/mapper';
import { SpecialSituationMessageVm } from '../../views/CallCenter/Settings/viewModel';
import Viewer from './MdEditor/Viewer.vue';

const { HomeService } = services;

export default (Vue as VueConstructor<Vue & {
}>).extend({
  name: 'MessageSpecialSituation',
  props: {
    collapsableMessage: {
      type: Boolean,
      required: false
    },
  },
  components: {
    viewer: Viewer
  },
  data() {
    return {
      dropdownTitles: [
        'Hinweis auf besondere Situation!'
      ] as string[],
      panel: [true],
      specialMessage: {} as SpecialSituationMessageVm,
      isVisibleMessage: false as boolean,
    };
  },
  created() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      this.$loader.show();
      HomeService.getMessage()
        .then((result: AxiosResponse<SpecialSituationMessage>) => {
          this.specialMessage = mapper.mapSpecialSituationMessageSpecialSituationMessageVm(result.data);
          this.isVisibleMessage = this.checkDateMessage();
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
        })
        .catch((err: AxiosError) => {
          if (err.response !== undefined && (err.response.status === 401 || err.response.status === 500)) {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.NotAuthorized);
            this.$router.push('/');
          } else {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.UnexpectedError);
          }
        });
    },
    checkDateMessage() {
      const actualDate = new Date();
      return actualDate >= this.specialMessage.dateFrom && actualDate <= this.specialMessage.dateTo;
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
  }
});
